export default {"src":"/fly/_next/static/media/mail.84e9ca3f.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};